import _Message2 from "@ks/kwai-ui/lib/theme-data/message.css";
import "@ks/kwai-ui/lib/theme-data/base.css";
import _Message from "@ks/kwai-ui/lib/message";
import _objectSpread from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "regenerator-runtime/runtime.js";
import axios from 'axios';
import { Jose } from '@ks-cqc/h5-sig4-lite';
import { radarLog } from '@/common/log';
var request = axios.create();
// 2、签名方法调用：通过config注入签名项，suc回调打印的的signResult即为签名的加密字符串
function getSig4(_x) {
  return _getSig.apply(this, arguments);
} // 3、获取签名版本号
function _getSig() {
  _getSig = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(config) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Promise(function (resolve, reject) {
              Jose.call('$encode', [config, {
                suc: function suc(signResult, signInput) {
                  resolve({
                    signResult: signResult,
                    signInput: signInput
                  });
                },
                err: function err(error) {
                  reject(error);
                }
              }]);
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getSig.apply(this, arguments);
}
function getSig4Ver() {
  return Jose.call('$getCatVersion') || '';
}
// 4、建议在网络库的拦截器里，将sig4参数拼接在url上
function generateSig4(_x2, _x3) {
  return _generateSig.apply(this, arguments);
} // perfetch 接口支持Sig4
function _generateSig() {
  _generateSig = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(axiosConfig, data) {
    var _axiosConfig$headers, _axiosConfig$headers2;
    var url, sig4Version, formdataParams, requestBodyParams, formParams, isPost, contentType, config, _yield$getSig, signResult, divider, sig4Url;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url = axiosConfig.url || '';
            if (url) {
              _context4.next = 3;
              break;
            }
            return _context4.abrupt("return");
          case 3:
            sig4Version = getSig4Ver();
            formdataParams = null;
            requestBodyParams = null;
            formParams = null;
            isPost = ['post', 'put', 'patch'].includes(axiosConfig.method || 'get');
            contentType = ((_axiosConfig$headers = axiosConfig.headers) === null || _axiosConfig$headers === void 0 ? void 0 : _axiosConfig$headers['Content-Type']) || ((_axiosConfig$headers2 = axiosConfig.headers) === null || _axiosConfig$headers2 === void 0 ? void 0 : _axiosConfig$headers2['content-type']) || 'application/json';
            if (isPost) {
              // content-type = 'application/x-www-form-urlencoded'的情况传入，其他情况可以不传或者传null
              formParams = contentType === 'application/x-www-form-urlencoded' ? data !== null && data !== void 0 ? data : null : null;
              // content-type = 'application/json'的情况传入,其他情况可以不传或者传null
              requestBodyParams = contentType === 'application/json' ? data !== null && data !== void 0 ? data : null : null;
            }
            // 需要把版本号也传入，参与签名生成；
            config = {
              url: url,
              query: _objectSpread({
                caver: sig4Version
              }, axiosConfig.params || {}),
              form: formParams,
              requestBody: requestBodyParams,
              projectInfo: {
                appKey: '7RVeauGG4t',
                did: '',
                uid: '',
                oversea: true,
                radarId: 'a5e81cbd04',
                sampling: 1,
                debug: false // 是否开启console.log打印，生产环境应禁用
              }
            };
            _context4.next = 13;
            return getSig4(config);
          case 13:
            _yield$getSig = _context4.sent;
            signResult = _yield$getSig.signResult;
            divider = url.includes('?') ? '&' : '?';
            sig4Url = "".concat(url).concat(divider, "__NS_hxfalcon=").concat(signResult, "&caver=").concat(sig4Version);
            return _context4.abrupt("return", sig4Url);
          case 18:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _generateSig.apply(this, arguments);
}
export function generateSig4Prefetch(_x4) {
  return _generateSig4Prefetch.apply(this, arguments);
}
// 添加请求拦截器
function _generateSig4Prefetch() {
  _generateSig4Prefetch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(preFetchParams) {
    var _Object$keys;
    var url, method, headers, data, params, sig4Version, requestBodyParams, formParams, isPost, contentType, newData, config, _yield$getSig2, signResult, divider, sig4Url;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            url = preFetchParams.url, method = preFetchParams.method, headers = preFetchParams.headers, data = preFetchParams.data, params = preFetchParams.params;
            if (url) {
              _context5.next = 3;
              break;
            }
            return _context5.abrupt("return");
          case 3:
            sig4Version = getSig4Ver();
            requestBodyParams = null;
            formParams = null;
            isPost = ['post', 'put', 'patch'].includes(method || 'get');
            contentType = (headers === null || headers === void 0 ? void 0 : headers['Content-Type']) || 'application/json';
            newData = data && (_Object$keys = Object.keys(data)) !== null && _Object$keys !== void 0 && _Object$keys.length ? data : null;
            if (isPost) {
              // content-type = 'application/x-www-form-urlencoded'的情况传入，其他情况可以不传或者传null
              formParams = contentType === 'application/x-www-form-urlencoded' ? newData : null;
              // content-type = 'application/json'的情况传入,其他情况可以不传或者传null
              requestBodyParams = contentType === 'application/json' ? newData : null;
            }
            // 需要把版本号也传入，参与签名生成；
            config = {
              url: url,
              query: _objectSpread({
                caver: sig4Version
              }, params || {}),
              form: formParams,
              requestBody: requestBodyParams,
              projectInfo: {
                appKey: '7RVeauGG4t',
                did: '',
                uid: '',
                oversea: true,
                radarId: 'a5e81cbd04',
                sampling: 1,
                debug: false // 是否开启console.log打印，生产环境应禁用
              }
            };
            _context5.next = 13;
            return getSig4(config);
          case 13:
            _yield$getSig2 = _context5.sent;
            signResult = _yield$getSig2.signResult;
            divider = url.includes('?') ? '&' : '?';
            sig4Url = "".concat(url).concat(divider, "__NS_hxfalcon=").concat(signResult, "&caver=").concat(sig4Version);
            return _context5.abrupt("return", sig4Url);
          case 18:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _generateSig4Prefetch.apply(this, arguments);
}
request.interceptors.request.use( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
    var sig4Url;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return generateSig4(config, config.data);
          case 3:
            sig4Url = _context.sent;
            config.url = sig4Url;
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            radarLog({
              name: 'Sig4',
              category: 'Sig4_Request_Err',
              extra_info: JSON.stringify({
                err: _context.t0
              })
            });
          case 10:
            return _context.abrupt("return", config);
          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));
  return function (_x5) {
    return _ref.apply(this, arguments);
  };
}());
request.interceptors.response.use( /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(response) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(response.status === 200)) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", Promise.resolve(response.data));
          case 2:
            return _context2.abrupt("return", Promise.reject(response));
          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function (_x6) {
    return _ref2.apply(this, arguments);
  };
}());
export default request;
/**
 * res.result !== 1 reject
 */
export function resultCodeCheck(_x7) {
  return _resultCodeCheck.apply(this, arguments);
}
function _resultCodeCheck() {
  _resultCodeCheck = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(res) {
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!(res.result === 1)) {
              _context6.next = 2;
              break;
            }
            return _context6.abrupt("return", res);
          case 2:
            _Message({
              type: 'error',
              message: res.message || '未知错误'
            });
            return _context6.abrupt("return", Promise.reject(res));
          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _resultCodeCheck.apply(this, arguments);
}